var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"boss-message-mail-subject"},[_vm._v("\n  "+_vm._s(_vm._f("formatSubject")(_vm.subject))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }